// Plugin sample

var yy = alasql.yy;

yy.Echo = function(params) {
    return yy.extend(this, params);
}

yy.Echo.prototype.execute = function(databaseid, params, cb) {
    var res = this.expr.execute(databaseid, params, (wb) => {
        if (cb) {
            function s2ab(s) {
                var buf = new ArrayBuffer(s.length);
                var view = new Uint8Array(buf);
                for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }
            cb(s2ab(alasql.utils.global.XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: false,
                type: 'binary'
            })));
        }
    });
    return res;
}